import { useState } from 'react';

export default function FlagIcon({ code, className = "w-6 h-4 object-cover" }) {
  const [imgError, setImgError] = useState(false);

  if (!code) return null;

  const isStateless = code === 'xx';
  const src = isStateless ? '/images/flags/xx.png' : `https://flagcdn.com/${code}.svg`;

  if (imgError) {
    return (
      <div 
        className={`rounded-[2px] shadow-sm shrink-0 flex items-center justify-center bg-gray-300 text-gray-500 font-bold ${className}`}
        style={{ aspectRatio: '4/3', fontSize: '10px' }}
      >
        XX
      </div>
    );
  }

  return (
    <img 
      src={src} 
      alt={`${code} flag`} 
      className={`rounded-[2px] shadow-sm shrink-0 flag-wave ${className}`} 
      style={{ aspectRatio: '4/3' }}
      onError={() => setImgError(true)}
    />
  );
}
